import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ROLES = ["Titolare/Proprietario","CEO/AD","Direttore Generale","Direttore HR","HR Manager","HR Specialist","Talent Acquisition Manager","Recruiter","Responsabile del Personale","Responsabile Amministrativo","Office Manager","Consulente del Lavoro","Consulente HR esterno","Altro"];
const EMP_COUNTS = ["1-10","11-50","51-150","151-500","500+"];
const REGIONS = ["Abruzzo","Basilicata","Calabria","Campania","Emilia-Romagna","Friuli Venezia Giulia","Lazio","Liguria","Lombardia","Marche","Molise","Piemonte","Puglia","Sardegna","Sicilia","Toscana","Trentino-Alto Adige","Umbria","Valle d'Aosta","Veneto"];

export default function CompleteProfilePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refreshUser } = useAuth();
  const user = location.state?.user;
  const [form, setForm] = useState({
    first_name: user?.first_name || "", last_name: user?.last_name || "",
    company_name: "", role: "", employee_count: "", region: ""
  });
  const [loading, setLoading] = useState(false);

  const up = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/complete-profile`, form, { withCredentials: true });
      await refreshUser();
      navigate("/dashboard", { replace: true });
    } catch { setLoading(false); }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#F4F7FB]" data-testid="complete-profile-page">
      <Card className="max-w-md w-full mx-4 border-[#0D1F3C]/8">
        <CardContent className="p-8">
          <h1 className="text-2xl font-bold text-[#0D1F3C] mb-1">SELLY<span className="text-[#56A3F5]">®</span></h1>
          <h2 className="text-lg font-medium text-[#0D1F3C] mt-3 mb-1">Completa il tuo profilo</h2>
          <p className="text-sm text-[#0D1F3C]/50 mb-6">Benvenuto! Completa i dati aziendali per iniziare.</p>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-2 gap-3">
              <div><Label className="text-xs mb-1 block">Nome</Label><Input value={form.first_name} onChange={e=>up("first_name",e.target.value)} required /></div>
              <div><Label className="text-xs mb-1 block">Cognome</Label><Input value={form.last_name} onChange={e=>up("last_name",e.target.value)} required /></div>
            </div>
            <div><Label className="text-xs mb-1 block">Nome Azienda *</Label><Input data-testid="profile-company" value={form.company_name} onChange={e=>up("company_name",e.target.value)} required /></div>
            <div><Label className="text-xs mb-1 block">Ruolo *</Label>
              <Select value={form.role} onValueChange={v=>up("role",v)}><SelectTrigger><SelectValue placeholder="Seleziona ruolo" /></SelectTrigger><SelectContent>{ROLES.map(r=><SelectItem key={r} value={r}>{r}</SelectItem>)}</SelectContent></Select></div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label className="text-xs mb-1 block">N. Dipendenti</Label>
                <Select value={form.employee_count} onValueChange={v=>up("employee_count",v)}><SelectTrigger><SelectValue placeholder="Seleziona" /></SelectTrigger><SelectContent>{EMP_COUNTS.map(c=><SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent></Select></div>
              <div><Label className="text-xs mb-1 block">Regione</Label>
                <Select value={form.region} onValueChange={v=>up("region",v)}><SelectTrigger><SelectValue placeholder="Seleziona" /></SelectTrigger><SelectContent>{REGIONS.map(r=><SelectItem key={r} value={r}>{r}</SelectItem>)}</SelectContent></Select></div>
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 bg-[#1B4FD8] hover:bg-[#0D1F3C]">
              {loading ? "Salvataggio..." : "Inizia a usare SELLY®"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
